import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  effect,
  input,
  signal,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'sia-map-button',
  templateUrl: './sia-map-button.component.html',
  styleUrls: ['./sia-map-button.component.scss'],
  standalone: true,
  imports: [MatIconButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaMapButtonComponent implements OnDestroy {
  readonly address = input<string>('');
  readonly isVisible = signal(false);
  private readonly _address = signal('');

  constructor() {
    effect(() => {
      const val = this.address();
      if (val) {
        this._address.set(val);
        this.isVisible.set(true);
        return;
      }

      this._address.set('');
      this.isVisible.set(false);
    });
  }

  @HostListener('window:unload')
  ngOnDestroy() {
    this._address.set('');
  }

  openMap() {
    const val = this._address();
    if (val) {
      window.open('http://maps.google.com/?q=' + val + '"');
    }
  }
}
